import { LOAD_CUSTOMERS, LOAD_CONTACTS, LOAD_LINE_USERS, LOAD_VERIFIED_USERS } from "./actions";

const initialState = {
  customers: {
    data: [],
    total_rows: 0,
    message: "",
  },
  contacts: {
    data: [],
    total_rows: 0,
    message: "",
  },
  lineUsers: {
    data: [],
    total_rows: 0,
    message: "",
  },
  verifiedUsers: {
    data: [],
    total_rows: 0,
    message: "",
  },
  loading: false,
  error: null,
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CUSTOMERS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOAD_CUSTOMERS.SUCCESS:
      const data = action.payload?.data || action.data;
      return {
        ...state,
        loading: false,
        customers: {
          data: data?.data || [],
          total_rows: data?.total_rows || 0,
          message: data?.message || "",
        },
        error: null,
      };

    case LOAD_CUSTOMERS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.err,
      };

    case LOAD_CONTACTS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOAD_CONTACTS.SUCCESS:
      const contactData = action.payload?.data || action.data;
      return {
        ...state,
        loading: false,
        contacts: {
          data: contactData?.data || [],
          total_rows: contactData?.total_rows || 0,
          message: contactData?.message || "",
        },
        error: null,
      };

    case LOAD_CONTACTS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.err,
      };

    case LOAD_LINE_USERS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOAD_LINE_USERS.SUCCESS:
      const lineUserData = action.payload?.data || action.data;
      return {
        ...state,
        loading: false,
        lineUsers: {
          data: lineUserData?.data || [],
          total_rows: lineUserData?.total_rows || 0,
          message: lineUserData?.message || "",
        },
        error: null,
      };

    case LOAD_LINE_USERS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.err,
      };

    case LOAD_VERIFIED_USERS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOAD_VERIFIED_USERS.SUCCESS:
      const verifiedData = action.payload?.data || action.data;
      return {
        ...state,
        loading: false,
        verifiedUsers: {
          data: verifiedData?.data || [],
          total_rows: verifiedData?.total_rows || 0,
          message: verifiedData?.message || "",
        },
        error: null,
      };

    case LOAD_VERIFIED_USERS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.err,
      };

    default:
      return state;
  }
};

export default customerReducer;
